module.exports = __webpack_public_path__ + "static/assets/c9c8ad44fb16101f2df1a63ef6eead13.gif";